// eslint-disable-next-line complexity
const deserializeDentalOffice = api => ({
  infoId: api.info_id ?? '',
  dentalId: api.dental_id ?? '',
  period: api.period ?? '',
  siren: api.siren ?? '',
  managementSoftware: (api.management_software || '').split(',') ?? [],
  surfaceSqm: api.surface_sqm ?? '',
  chairCount: api.chair_count ?? '',
  dentistCount: api.dentist_count ?? '',
  collabDentistCount: api.collab_dentist_count ?? '',
  chairsideAssistantCount: api.chairside_assistant_count ?? '',
  hasEmployedProsthetist: api.has_employed_prosthetist ?? false,
  hasRadio2d: api.has_radio_2d ?? false,
  hasRadio3d: api.has_radio_3d ?? false,
  hasSalesAssistant: api.has_sales_assistant ?? false,
  hasSecretarialAssistant: api.has_secretarial_assistant ?? false
});

export default deserializeDentalOffice;
